module.exports = __webpack_public_path__ + "img/42105023000100.4cd4c3e9.png";